import pickleballIcon from "../pickleball.png";

const SPORTS = {
  tennis:      { icon: "🎾", label: "테니스" },
  soccer:      { icon: "⚽", label: "축구" },
  futsal:      { icon: "🥅", label: "풋살" },
  badminton:   { icon: "🏸", label: "배드민턴" },
  basketball:  { icon: "🏀", label: "농구" },
  bowling:     { icon: "🎳", label: "볼링" },
  tabletennis: { icon: "🏓", label: "탁구" },
  baseball:    { icon: "⚾", label: "야구" },
  golf:        { icon: "⛳", label: "골프" },
  running:     { icon: null, label: "피클볼" },
  billiards:   { icon: "🎱", label: "당구" },
};

// teams 배열은 호출자가 팀장 팀만 걸러서 전달해야 함
export default function TeamSelectModal({ teams, onSelect, onClose }) {
  return (
    <div style={sm.backdrop} onClick={onClose}>
      <div style={sm.box} onClick={e => e.stopPropagation()}>
        <div style={sm.header}>
          <span style={sm.title}>어느 팀으로 신청할까요?</span>
          <button style={sm.closeBtn} onClick={onClose}>✕</button>
        </div>
        {teams.map(team => {
          const sport = SPORTS[team.sports_type] || { icon: "🏅", label: team.sports_type };
          const icon  = sport.icon
            ? <span style={{ fontSize: 24 }}>{sport.icon}</span>
            : <img src={pickleballIcon} alt="피클볼" style={{ width: 24, height: 24, objectFit: "contain" }} />;
          return (
            <div key={team.id} style={sm.card} onClick={() => onSelect(team)}>
              {icon}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={sm.teamName}>{team.team_name}</div>
                <div style={sm.teamSub}>{sport.label}{team.level ? ` · ${team.level}` : ""}</div>
              </div>
              <span style={sm.arrow}>›</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const sm = {
  backdrop: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 350, padding: "0 20px",
  },
  box: {
    background: "#fff", borderRadius: 16,
    width: "100%", maxWidth: 340,
    padding: "20px 16px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    fontFamily: "'Noto Sans KR', sans-serif",
    maxHeight: "70vh", overflowY: "auto",
  },
  header: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    marginBottom: 16,
  },
  title: { fontSize: 16, fontWeight: 700, color: "#111827" },
  closeBtn: {
    background: "none", border: "none", fontSize: 18,
    color: "#9ca3af", cursor: "pointer", padding: 4,
    lineHeight: 1, fontFamily: "inherit",
  },
  card: {
    display: "flex", alignItems: "center", gap: 12,
    padding: "14px 12px", borderRadius: 12, marginBottom: 8,
    border: "1px solid #e5e7eb", cursor: "pointer",
    background: "#f9fafb",
  },
  teamName: { fontSize: 15, fontWeight: 700, color: "#111827", marginBottom: 2 },
  teamSub:  { fontSize: 12, color: "#9ca3af" },
  arrow:    { fontSize: 18, color: "#9ca3af", flexShrink: 0 },
};
